// <- TaskManagment.js
import React, { useState, Fragment, useEffect, useMemo } from "react";
import TableWithSortPagtn from "../../common/TableForLeaveSummaryReport";
import { Table } from "semantic-ui-react";
import moment from "moment";

const loginUser = JSON.parse(localStorage.getItem("user"));
let maxwidth = "80vw";

const ListAttendanceSummary = React.memo(
  ({
    handleAddEditTaskForm,
    handleSelectedTask,
    handleOpenCalendar,
    handleDelTask,
    empTask,
    taskProjectInfo,
    handleToggleAllTaskCalendar,
    getAllTaskOfEmployee,
    handleUnlockRequestForm,
    disablePagination,
  }) => {
    const [thead] = useState([
      "#",
      "Employee ID",
      "Employee Name",
      "Date",
      "Department",
      "First In",
      "Last Out",
      "Total Duration",
      "Office Hours",
      "Duty Hours",
      "Duty Type",
      "Total Billable Hours",
    ]);

    const [trow, setTrow] = useState([]);

    // Build trow for table
    useEffect(() => {
      if (empTask && empTask.length > 0) {
        const rows = empTask.map((record, index) => ({
          "#": index + 1,
          "Employee ID": record.employeeCode,
          "Employee Name": record.employeeName,
          Date: record.attendanceDate
            ? new Date(record.attendanceDate).toLocaleDateString("en-GB")
            : "-",
          Department: record.departmentName,
          "First In": record.firstPunchIn,
          "Last Out": record.lastPunchOut,
          "Total Duration": record.totalHours,
          "Office Hours": record.officeHours,
          "Duty Hours": record.dutyHours,
          "Duty Type": record.dutyTypeName,
          "Total Billable Hours": record.totalBillableHours,
        }));
        setTrow(rows);
      } else {
        setTrow([]);
      }
    }, [empTask]);

    return (
      <Fragment>
        <div style={{ maxWidth: maxwidth, overflowY: disablePagination ? "visible !important" : "auto", maxHeight: disablePagination ? "auto !important" : "80vh" }}>
          {trow.length > 0 ? (
            <TableWithSortPagtn
              thead={thead}
              trow={trow}
              pageSize={10} // consistent pagination
              disablePagination={disablePagination}
            />
          ) : (
            <div style={{ textAlign: "center", padding: "10px" }}>
              No attendance records found.
            </div>
          )}
        </div>
      </Fragment>
    );
  }
);

export default ListAttendanceSummary;